export default "__VITE_ASSET__dc128dce__"